import { StorageService } from './storage.service';
import _ from 'lodash';

const KEY = 'cart';

function addToCart(product, qiuckAdd, quant) {
    let cart = StorageService.load(KEY)

    for (let i = 0; i < cart.length; i++) {
        if (_.isEqual(cart[i], product)) {
            
            cart[i].quantity = quant
            StorageService.save(KEY, cart)
            return JSON.parse(JSON.stringify(product.product || product))
                }
    }

    if (!product.size || qiuckAdd) {
        product.size = 36
    } else {
        product.product.size = JSON.parse(product.size)
    }

    if (!cart) {
        StorageService.save(KEY, [product.product || product])
        return (JSON.parse(JSON.stringify(product.product || product)))
    }
    cart.unshift(product.product || product)
    StorageService.save(KEY, cart)
    return JSON.parse(JSON.stringify(product.product || product))
}

function removeFromCart(product) {
    let cart = StorageService.load(KEY)

    if (cart[product.id]) {
        if (cart[product.id].quantity > 1) cart[product.id].quantity -= 1
    }

    let newCart = cart.filter(cartItem => {
        return product.id !== cartItem.id
    })
    newCart = JSON.parse(JSON.stringify(newCart));
    StorageService.save(KEY, newCart)
    return product
}

function loadCart() {
    let cart = StorageService.load(KEY)
    if (!cart) {
        StorageService.save(KEY, [])
        cart = []
    }
    return cart
}

export const CartService = {
    addToCart,
    loadCart,
    removeFromCart
}